module.exports = __webpack_public_path__ + "static/media/adWhite.176bb1ec.svg";